export default class DtoObservatoryFollowData {
    constructor(obj) {
        this.value = obj.value
        this.color = obj.color
    }
}